/**
 * Import dependencies.
 */
import {h, Component} from 'preact';
import classnames from 'classnames/dedupe';

/**
 * Import local dependencies.
 */

/**
 * Import styles.
 */
import '@material/toolbar/mdc-toolbar.scss';

/**
 * Create the component.
 */
export default class ToolbarSection extends Component {
  render({
           'class': className,
           start,
           end,
           children,
           ...props
         }, state, context) {
    const classes = classnames('mdc-toolbar__section', {
      'mdc-toolbar__section--align-start': start,
      'mdc-toolbar__section--align-end': end
    }, className);
    return (
      <section class={classes} {...props}>{children}</section>
    );
  }
}



// WEBPACK FOOTER //
// ../q-mdc/elements/material-toolbar-section/index.js